import Tippy from '@tippyjs/react';
import { FC } from 'react';
import styles from './index.module.scss';

interface TooltipProps {
  tooltip: string;
}

export const TooltipWrapper: FC<TooltipProps> = ({ tooltip }) => {
  return (
    <Tippy content={tooltip}>
      <span className={styles.wrapper}>
        <i className='fa-regular fa-circle-question'></i>
      </span>
    </Tippy>
  );
};
